var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"value":_vm.value,"clearable":"","filterable":"","disabled":_vm.readonly},on:{"change":_vm.handlerChange}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.name,"value":item[_vm.need]}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }